import { DC_FORM_ANKETA_PATH } from '@alfa-bank/site-dc-env-config';

export const ACTION_PATH = DC_FORM_ANKETA_PATH();
